import { render, staticRenderFns } from "./B-3-2-1__BUPageEdit_BUMessage.vue?vue&type=template&id=32c88082&"
import script from "./B-3-2-1__BUPageEdit_BUMessage.vue?vue&type=script&lang=js&"
export * from "./B-3-2-1__BUPageEdit_BUMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
